import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../../../consts/api";

export const useExportVerticalsReportDetails = (payload, options = {}) => {
  const res = useMutation(
    async (payload) =>
      http.get(HTTP_ENDPOINTS.verticalsUsageReportDetails(), {
        params: { ...payload, export: true },
      }),
    options,
  );
  return res;
};
